<div class="option-group-header">
  <wchfs-checkbox (change)="toggleCheckbox($event)" *ngIf="select.multiselect" [checked]="checked"></wchfs-checkbox>

  <div #header (click)="onHeaderClick()" class="content">
    <ng-content></ng-content>
    <wchfs-icon svgIcon="wchfs:arrow-down"></wchfs-icon>
  </div>
</div>
